/* 商品接口 */
import http from '@/utils/http'
import config from '@/config/config'

const api = {
  getCouponSpec: config.eventRoot + '/gbb/double112019/getCouponSpec',
  getCouponAudioGoodsList: config.eventRoot + '/gbb/double112019/getTopicAudioListByCoupon'
}

/**
 * 获取优惠券规格信息
 */
export function getCouponSpecInfo(couponSpecId) {
  return http.get(api.getCouponSpec, {
    'coupon_spec_id': couponSpecId
  })
}
/**
 * 根据优惠券规格获取音频商品列表
 */
export function getCouponAudioGoodsList(topicId, couponSpecId, userId) {
  return http.get(api.getCouponAudioGoodsList, {
    'topic_id': topicId,
    'coupon_spec_id': couponSpecId,
    'user_id': userId
  })
}
